<template>
  <UserCommunications
    :user-id="id"
    recipient-type="customer"
    recipient-label="заказчику"/>
</template>

<script>
import UserCommunications from '@/components/User/UserCommunications.vue';

export default {
  components: { UserCommunications },
  props: {
    id: { type: [Number, String], required: true },
  },
};
</script>
